import { render, staticRenderFns } from "./OperaProjectRoleSorcelListWindow.vue?vue&type=template&id=3c8d3194&scoped=true&"
import script from "./OperaProjectRoleSorcelListWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectRoleSorcelListWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectRoleSorcelListWindow.vue?vue&type=style&index=0&id=3c8d3194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d3194",
  null
  
)

export default component.exports